
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link, useNavigate } from "react-router-dom";

const PREMIUM_RESET_SLUG_STORAGE_KEY = 'premium-reset-slug';

const Index = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;

    const hashParams = new URLSearchParams(hash.substring(1));
    if (hashParams.get('type') !== 'recovery') return;

    let storedSlug = '';
    try {
      storedSlug = localStorage.getItem(PREMIUM_RESET_SLUG_STORAGE_KEY)?.trim() || '';
    } catch {
      // ignore storage errors
    }

    const slugQuery = storedSlug ? `?slug=${encodeURIComponent(storedSlug)}` : '';
    navigate(`/premium-reset-password${slugQuery}${hash}`, { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 mb-4">
            Assessment Platform
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            Professional assessment management system
          </p>
        </div>
        
        <div className="space-y-4">
          <Button asChild className="w-full" size="lg">
            <Link to="/admin">
              Access Admin Dashboard
            </Link>
          </Button>
          
          <p className="text-sm text-gray-500">
            Admin access required. Contact your administrator for access.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Index;
